/**
 * 相対取引一覧フィルタの選択肢定義。
 *
 * 表示文言は i18n key で持ち、component 側で解決する。
 */
import { TradingExecutionRoute } from '@ebalance/proto/bfftypes/v1/trading_execution_route_pb'

export type SelectOption = {
  /** select の value (= 数値 enum の string 化)。 */
  value: string
  /** 表示文言の i18n key。 */
  labelKey: string
}

/**
 * 一覧フィルタの約定経路の選択肢 (固定 6 値 + MANUAL)。
 *
 * 固定 6 値は `bilateral-trade-list.md` §表示項目の個別入力の固定候補。
 * フィルタは既存データを絞り込む用途なので、 新規登録の候補にならない
 * MANUAL (= 旧「手入力」) も
 * 対象に含める (`bilateral-trade-list.md` の「固定 6 種 + データ内で既出の
 * ルートを動的統合」に対応する固定分)。
 */
export const EXECUTION_ROUTE_FILTER_OPTIONS: SelectOption[] = [
  {
    value: String(TradingExecutionRoute.ENECHAIN),
    labelKey: 'page:supplyBilateral.executionRoute.enechain',
  },
  {
    value: String(TradingExecutionRoute.ESQUARE_LIVE),
    labelKey: 'page:supplyBilateral.executionRoute.eSquareLive',
  },
  {
    value: String(TradingExecutionRoute.BASELOAD_MARKET),
    labelKey: 'page:supplyBilateral.executionRoute.baseloadMarket',
  },
  {
    value: String(TradingExecutionRoute.FORWARD_MARKET),
    labelKey: 'page:supplyBilateral.executionRoute.forwardMarket',
  },
  {
    value: String(TradingExecutionRoute.BACKUP_REGULAR),
    labelKey: 'page:supplyBilateral.executionRoute.backupRegular',
  },
  {
    value: String(TradingExecutionRoute.OTHER),
    labelKey: 'page:supplyBilateral.executionRoute.other',
  },
  {
    value: String(TradingExecutionRoute.MANUAL),
    labelKey: 'page:supplyBilateral.executionRoute.manual',
  },
]
